import req from "../http";

const interviewPlace = {
  // 取得 面談地點
  getInterviewPlacePaging(params) {
    return req("get", "/BasicInformation/InterviewPlace/Paging", params);
  },

  // 新增 面談地點
  postInterviewPlace(params) {
    return req("post", "/BasicInformation/InterviewPlace", params);
  },

  // 更新 面談地點
  putInterviewPlace(params) {
    return req("put", "/BasicInformation/InterviewPlace", params);
  },

  // 刪除 面談地點
  deleteInterviewPlace(params) {
    return req("delete", "/BasicInformation/InterviewPlace", params);
  },
};

export default interviewPlace;